import { Flex } from "@chakra-ui/react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_layout")({
  component: () => (
    <Flex
      minHeight="100vh"
      direction="column"
      maxW="8xl"
      mx="auto"
      // required to make up for "viewport-fit=cover" on mobile devices (e.g. iPhones); see https://fathomtech.io/blog/designing-react-web-applications-for-the-notch/
      padding="env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)"
      id="main-scrollable-area"
    >
      <Outlet />
    </Flex>
  ),
});
